module.exports = __webpack_public_path__ + "img/9788958280491.ec6c3859.jpg";